export const ACTIVITIES_PER_PAGE = 5;

export const DRAWER_WIDTH = '240px';
export const DRAWER_WIDTH_CLOSED = '65px';

export const NAVBAR_HEIGHT = '74px';

export const NOTIFICATION_PANEL_WIDTH = '530px';

export const SEARCH_DEBOUNCE_MS = 250;
export const LOADING_INDICATOR_DELAY_MS = 300;
export const MAX_RESULTS_PER_GROUP = 5;
export const MAX_RECENT_VIEWS = 8;
export const RECENT_VIEWS_KEY = 'slabstack_recent_views';
export const PUSH_TOKEN_STORAGE_KEY = 'push_token';
export const SEARCH_DROPDOWN_MAX_WIDTH = 841;
export const CONFIRM_DIALOG_MAX_WIDTH = 512;
export const DRAWER_DISCARD_PROMPT_MAX_WIDTH = 640;

export const AI_THINKING_THRESHOLD_MS = 3000;

export const MOBILE_APP_STORE_URL = 'https://apps.apple.com/app/slabstack/id6504748165';
export const MOBILE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.slabstack.prod';
export const MOBILE_DEEP_LINK_SCHEME = 'slab://';

export const DEFAULT_REFERRAL_EMAIL_BODY = `<p style="margin:0">Hey [First Name]</p><p style="margin:0"><br></p><p style="margin:0"><p>We started using <b>Slabstack</b> to streamline quoting and manage margins more effectively and it's been a <b>game changer</b>.</p><br /><p>If you're still juggling spreadsheets or struggling with slow quote turnaround, I think you'd really benefit from it. You can see exactly where you're making (or losing) money, and quoting takes a fraction of the time.</p><br /><p>If you like what you see in a demo and sign up as a customer, <b>you'll get a $250 credit</b> and I'll get a $250 gift card. Win-win.</p><br /><p>Let me know if you have any questions. Happy to tell you more about our experience.</p></p><p style="margin:0"><br></p><p style="margin:0">– [Contact Name]</p><p style="margin:0">[Company Name]</p>`;

export const DEFAULT_ALL_VALUE_FOR_SELECT = 'DEFAULT_ALL_VALUE_FOR_SELECT';
export const TABLE_FILTER_VISIBLE_VALUES = 1;

export const ROWS_PER_PAGE_OPTS = [10, 25, 50];
export const EMPTY_LINE_CHAR = '\u00A0';

export const AUTO_DISMISS_DURATION = 8000;

export const TOAST_CONFIG = { autoDismissDuration: AUTO_DISMISS_DURATION };

export const SIGNATURES_PER_PAGE = 10;

/** Roughly national scale — wide enough to bias without excluding neighbours. */
export const AUTOCOMPLETE_BIAS_RADIUS_METRES = 2_000_000;

export const SKELETON_LIST_COUNT = 5;
export const SKELETON_MONTHLY_BREAKDOWN_COUNT = 12;

// The server lease is 30s; renewing every 10s survives one missed heartbeat.
export const QUOTE_EDIT_LOCK_HEARTBEAT_MS = 10_000;
export const QUOTE_EDIT_LOCK_EXPIRY_GRACE_MS = 1_000;
export const QUOTE_EDIT_LOCK_FALLBACK_MESSAGE = 'Another user is currently editing this quote';

export const VIEW_ONLY_FIELDS_OPACITY = 0.6;

export const SUSPENDED_ORDERS_COLLAPSED_COUNT = 3;
